import { Route } from 'react-router-dom';

// Placeholder for future mentee routes
export const menteeRoutes = [];